/**
 * True when the host is one of the domains or a subdomain of one. Matching is anchored on a
 * leading dot, so a lookalike host (`notspiris.se`, `spiris.se.evil.example`) fails the check. An
 * empty domain matches nothing, or every host ending in a dot (`evil.example.`) would pass.
 */
export function hostMatchesDomain(hostname: string, domains: readonly string[]): boolean {
    const host = hostname.toLowerCase();
    return domains.some((domain) => domain !== '' && (host === domain || host.endsWith(`.${domain}`)));
}
